import { makeStyles, fade } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    alignSelf: 'flex-start',
    background: theme.palette.custom.background.area,
    boxShadow: theme.shadows[25],
    margin: `${theme.spacing(3)}px auto`,
    maxWidth: theme.spacing(80),
    overflow: 'hidden',
    maxHeight: `calc(100% - ${theme.spacing(6)})`,

    [theme.breakpoints.down('xs')]: {
      margin: theme.spacing(3, 0),
    },

    '& .confirmation': {
      '&-header': {
        display: 'flex',
        alignItems: 'center',
        height: theme.spacing(21 / 2),
        minHeight: theme.spacing(21 / 2),
        padding: theme.spacing(0, 3),
        color: theme.palette.text.secondary,
      },
      '&-body': {
        overflow: 'auto',
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
      },
      '&-footer': {
        display: 'flex',
        alignItems: 'center',
        height: theme.spacing(8),
        minHeight: theme.spacing(8),
        padding: theme.spacing(0, 2),
        borderTop: `solid 1px ${theme.palette.divider}`,
      },
      '&-info': {
        '&-container': {
          display: 'flex',
          flexDirection: 'column',
          padding: theme.spacing(3),
          position: 'relative',

          '&:not(:last-of-type):after': {
            content: '""',
            width: `calc(100% - ${theme.spacing(3)}px)`,
            height: 1,
            display: 'block',
            background: theme.palette.divider,
            position: 'absolute',
            bottom: 0,
            right: 0,
          },
        },
        '&-label': {
          color: theme.palette.text.hint,
          marginBottom: theme.spacing(1),
        },
        '&-content': {
          display: 'flex',
          alignItems: 'flex-start',
        },
        '&-icon': {
          '&-container': {
            width: theme.spacing(5),
            height: theme.spacing(5),
            background: fade(theme.palette.primary.main, 0.2),
            marginRight: theme.spacing(2),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '50%',
          },
        },
        '&-text': {
          '&-container': {
            display: 'flex',
            flexDirection: 'column',
          },
          '&-primary': {
            color: theme.palette.text.secondary,
            fontWeight: 'bold',
          },
          '&-secondary': {
            color: theme.palette.text.secondary,
          },
        },
      },
      '&-terms': {
        '&-container': {
          padding: theme.spacing(3),
          color: theme.palette.text.secondary,
        },
        '&-link': {
          '&:hover': {
            color: theme.palette.primary.main,
          },
        },
      },
      '&-btn-confirm': {
        marginLeft: 'auto',
        color: theme.palette.custom.feedback.positive,
      },
    },
  },
}));

export default styles;
